const initialState: Array<object> = [];



/**
 * trainingListDataReducer: Reducer to manage the training list data state.
 *
 * @param {Array<object>} state - The current state of the training list data.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {Array<object>} The updated state based on the action type.
 */

const trainingListDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_TRAINING_LIST_DATA":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default trainingListDataReducer;
